export const homeObjFive = {
  id: "services",
  lightBg: true,
  lighText: false,
  lightTextDesc: false,
  topLine: " ",
  headline: "",
  description: "",
};
